module.exports = __webpack_public_path__ + "img/leumicard-stacked.37d68f48.png";